import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Keyboard, X } from 'lucide-react'

const shortcuts = [
  { key: '←', description: 'Previous slide' },
  { key: '→', description: 'Next slide' },
  { key: 'Space', description: 'Next slide' },
  { key: 'Home', description: 'First slide' },
  { key: 'End', description: 'Last slide' },
  { key: 'A', description: 'Toggle auto-play' },
  { key: 'Esc', description: 'Stop auto-play' },
]

export default function KeyboardHints() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="fixed top-6 right-6 z-50">
      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="glass p-3 rounded-full transition-all duration-300 hover:glow-purple"
        aria-label="Keyboard shortcuts"
      >
        {isOpen ? (
          <X className="w-5 h-5 text-white" />
        ) : (
          <Keyboard className="w-5 h-5 text-white" />
        )}
      </motion.button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="absolute top-full right-0 mt-3 glass-strong rounded-2xl p-5 min-w-[220px]"
          >
            <h3 className="text-sm font-semibold text-electric-cyan mb-4">
              Keyboard Shortcuts
            </h3>
            <ul className="space-y-2">
              {shortcuts.map((shortcut) => (
                <li key={shortcut.key} className="flex items-center justify-between gap-4">
                  <span className="text-white/60 text-sm">{shortcut.description}</span>
                  <kbd className="bg-space-700 px-2 py-1 rounded text-xs font-mono text-white/80 min-w-[40px] text-center">
                    {shortcut.key}
                  </kbd>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
